import React from 'react';
import PropTypes from 'prop-types';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  makeStyles,
} from '@material-ui/core';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { Draggable } from 'react-beautiful-dnd';

const useStyles = makeStyles(() => ({
  draggingListItem: {
    background: 'rgb(235,235,235)',
  },
  listItemSecondaryAction: {
    visibility: "hidden",
  },
  listItem: {
    "&:hover $listItemSecondaryAction": {
      visibility: "inherit"
    }
  },
  listItemText: {
    fontSize:"14px"
  },
  ListItemSecondaryAction: {
    fontSize: "12px"
  }
}));

const DraggableListItem = ({ item, index, actionItems, labelKey, actionOnHover, showSecondaryText }) => {
  const classes = useStyles();
  return (
    <Draggable draggableId={labelKey ? item[labelKey] : item} index={index}>
      {(provided, snapshot) => (
        <ListItem
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={
            snapshot.isDragging
              ? `${classes.draggingListItem} box-shadow`
              : 'box-shadow'
          }
          classes={{
            container: classes.listItem
          }}
        >
          <ListItemIcon>
            <DragIndicatorIcon></DragIndicatorIcon>
          </ListItemIcon>
          <ListItemText primary={labelKey ? item[labelKey] : item} classes={{ primary: classes.listItemText }}  secondary={(showSecondaryText && item.isDefault) ? "Default" : "" }  />
          <ListItemSecondaryAction className={actionOnHover ? classes.listItemSecondaryAction : ""}>
            {actionItems ? actionItems(item, index) : <></>}
          </ListItemSecondaryAction>
        </ListItem>
      )}
    </Draggable>
  );
};

DraggableListItem.propTypes = {
  item: PropTypes.any.isRequired,
  index: PropTypes.number.isRequired,
  actionItems: PropTypes.func,
  labelKey: PropTypes.string,
  actionOnHover: PropTypes.bool,
  showSecondaryText: PropTypes.bool
};

DraggableListItem.defaultProps = {
  showSecondaryText: false
}

export default DraggableListItem;
